var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 0.25C5.19406 0.25 1.98369 3.08406 1.51161 6.86064L0.522696 14.772C0.325033 16.3533 1.55802 17.75 3.15163 17.75H4.5126L4.56494 17.8678C5.34391 19.6205 7.08201 20.75 9 20.75C10.918 20.75 12.6561 19.6205 13.4351 17.8678L13.4874 17.75H14.8484C16.442 17.75 17.675 16.3533 17.4774 14.772L16.4884 6.86064C16.0164 3.08406 12.806 0.25 9.00003 0.25ZM13.0171 16.25C13.006 16.2498 12.9948 16.2498 12.9837 16.25H5.01629C5.00518 16.2498 4.99404 16.2498 4.98288 16.25H3.15163C2.46027 16.25 1.92536 15.6441 2.01111 14.958L3.00003 7.04669C3.37827 4.02075 5.95054 1.75 9.00003 1.75C12.0495 1.75 14.6218 4.02075 15 7.04669L15.9889 14.958C16.0747 15.6441 15.5398 16.25 14.8484 16.25H13.0171ZM6.20521 17.75H11.7948C11.1806 18.6765 10.136 19.25 9 19.25C7.86403 19.25 6.81939 18.6765 6.20521 17.75Z",
    fill: "#22282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.33e672daa8ab64a8e721cb7cab4bf311.svg";
export { ForwardRef as ReactComponent };